<template>
  <div v-if="showing" class="container">
    <div class="row">
      <div class="col-lg-24">
        <div
          class="alert alert-dismissible mt-2 mb-0"
          v-bind:class="'alert-' + color"
          role="alert"
        >
          <strong v-if="title">{{ title }} </strong><span v-html="text"></span>
          <button
            type="button"
            class="close"
            @click="close()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: "global-alert",

  data() {
    return {
      title: null,
      showing: false,
      color: "warning",
      text: null
    };
  },

  mounted() {
    Event.$on("serverError", this.serverError);
    Event.$on("successAlert", this.success);
  },

  methods: {
    close() {
      this.color = "warning";
      this.title = null;
      this.text = null;
      this.showing = false;
    },

    success(object = null) {
      if (object) {
        return this.showAlert(object.color, object.title, object.text);
      }

      return this.showAlert(
        "success",
        "Success!",
        "That action has been completed successfully."
      );
    },

    serverError() {
      this.$SmoothScroll(0);
      this.showAlert(
        "danger",
        "Whoops!",
        "It looks like we had trouble processing that, please try again or <a href='/contact' target='_blank'>contact us</a> if problems persist."
      );
    },

    showAlert(color, title = null, text) {
      this.color = color;
      this.title = title;
      this.text = text;
      this.showing = true;
    }
  }
};
</script>
